

$(function () {
    setTimeout(function () {

        function init(el,fn){
            if($(el).length>0 && typeof fn ==='function') fn(el);
        }

        init('.js-ajax', cwMjs.common.ajaxSetup);

        //index
        init('.p-index',cwMjs.index.init);

        //article
        init('.js-mood-box',cwMjs.article.mood);
        init('.js-article-section-load',cwMjs.column.articleSectionLoad);
        init('.js-article-search-load',cwMjs.column.articleSearchLoad);
        init('.js-topic-article-load',cwMjs.column.topicArticleLoad);
        init('.js-author-article-load',cwMjs.column.authorArticleLoad);
        init('.js-author-load',cwMjs.column.authorLoad);
        init('.js-topic-load',cwMjs.column.topicLoad);

        //author
        init('.author-index-list',cwMjs.author.switchAuthorIndex);

        //common
        init('.btn-show-nav',cwMjs.common.showNav);
        init('.switch-to-web', cwMjs.common.switchToWeb);
        init('footer',cwMjs.common.fixedFooter);
        init('.btn-back-top',cwMjs.common.backTop);
        init('.btn_side',cwMjs.common.open_side);



    },1);
});